export default __webpack_public_path__ + "static/media/etc.f3a262b0.png";